<template>
  <iColumn
    width="fill"
    height="hug"
    gap="standard"
  >
    <template
      v-for="(block, blockIndex) in blocks"
      :key="blockIndex"
    >
      <iRow
        v-if="block.marker"
        width="fill"
        height="hug"
        gap="extraSmall"
        vertical-align="top"
        wrap="nowrap"
      >
        <iText
          v-bind="fullTextOptionsAttributes"
          :style-overrides="fullTextOptionsAttributes.textStyleOverrides"
          width="hug"
        >
          {{ block.marker }}
        </iText>
        <iText
          v-bind="fullTextOptionsAttributes"
          :style-overrides="fullTextOptionsAttributes.textStyleOverrides"
          width="fill"
          :min-width="0"
          :overflow="true"
        >
          <template
            v-for="(run, runIndex) in block.runs"
            :key="runIndex"
          >
            <strong v-if="run.strong">{{ run.text }}</strong>
            <span v-else>{{ run.text }}</span>
          </template>
        </iText>
      </iRow>
      <iText
        v-else
        v-bind="fullTextOptionsAttributes"
        :style-overrides="fullTextOptionsAttributes.textStyleOverrides"
        width="fill"
        :min-width="0"
        :overflow="true"
        :font-weight="headingWeight(block) || fullTextOptionsAttributes.fontWeight"
        :font-size="headingSize(block) || fullTextOptionsAttributes.fontSize"
      >
        <template
          v-for="(run, runIndex) in block.runs"
          :key="runIndex"
        >
          <strong v-if="run.strong">{{ run.text }}</strong>
          <span v-else>{{ run.text }}</span>
        </template>
      </iText>
    </template>
  </iColumn>
</template>

<script>
import { camelToTitleCase } from "@bloglovin/vue-framework";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import { StaticBrandedTextElementMixin }
  from "%/dynamic-component-editor/standard-elements/text-element/static-branded-text-element-mixin";
import { markdownBlocks, BLOCK_HEADING }
  from "%/dynamic-component-editor/helpers/markdown-blocks";

const HEADING_SIZES = ["extraLarge", "large", "large", "standard", "standard", "standard"];

export default {
  name: "DynamicAppMarkdownElement",
  mixins: [DynamicElementMixin, DynamicElementWithContext, StaticBrandedTextElementMixin],
  elementPanelSettings: {
    displayName: "Prose",
    elementGroup: "general",
    displayIcon: "text",
    elementType: "element",
  },
  hidden: true,
  computed: {
    isEditable() {
      return false;
    },
    blocks() {
      const parsed = markdownBlocks(this.valueFromContext);
      if (parsed.length > 0) {
        return parsed;
      }
      if (this.editMode || this.isPreviewMode) {
        return markdownBlocks(this.placeholderText);
      }
      return [];
    },
    placeholderText() {
      if (this.exampleData) {
        return this.exampleData;
      }
      const field = this.elementContext?.field;
      return field ? camelToTitleCase(field) : this.$options.elementPanelSettings.displayName;
    },
  },
  methods: {
    headingWeight(block) {
      return block.type === BLOCK_HEADING ? "dark" : "";
    },
    headingSize(block) {
      if (block.type !== BLOCK_HEADING) {
        return "";
      }
      return HEADING_SIZES[block.level - 1];
    },
  },
};
</script>
